module.exports = global["$"] = require("-!/Users/cornelis/Sites/stichting-inclusief-jodendom/node_modules/expose-loader/index.js?jQuery!./jquery.js");